const darkThemePalette = {
  primary: {
    main: '#e2e8f0',
    light: '#f8fafc',
    dark: '#cbd5e1',
    contrastText: '#0f172a',
  },
  secondary: {
    main: '#60a5fa',
    light: '#93c5fd',
    dark: '#2563eb',
    contrastText: '#0f172a',
  },
  tertiary: {
    main: '#0f172a',
    dark: '#020617',
  },
  typography: {
    main: '#e2e8f0',
    dark: '#f8fafc',
  },
  background: {
    default: '#020617',
    paper: '#0f172a',
  },
  text: {
    primary: '#e2e8f0',
    secondary: '#94a3b8',
  },
  divider: '#1e293b',
};

export default darkThemePalette;
